"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.Http = exports.ErrorDataCode = void 0;
var fetch_1 = require("rxjs/fetch");
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var ErrorDataCode;
(function (ErrorDataCode) {
    ErrorDataCode["InvalidSessionId"] = "InvalidSessionId";
    ErrorDataCode["NotAcceptable"] = "INVALID_MODEL_STATE";
})(ErrorDataCode = exports.ErrorDataCode || (exports.ErrorDataCode = {}));
var onSuccessFetch = function (response) {
    if (isResponseWithoutContent(response)) {
        return rxjs_1.of({}).toPromise();
    }
    if (!response.ok) {
        return response.json().then(function (body) {
            return error(getErrorMessage(response.statusText, response.status, body)).toPromise();
        });
    }
    else {
        return response.json();
    }
};
var onErrorFetch = function (err) { return error(getErrorMessage(err.message, err.status, err.body)); };
var error = function (err) { return rxjs_1.throwError(err); };
var isInvalidSessionResponse = function (err) {
    return err.status === 400 && err.body && err.body.Code === ErrorDataCode.InvalidSessionId;
};
var isNotAcceptableResponse = function (err) {
    return err.status === 406 && err.body && err.body.Code === ErrorDataCode.NotAcceptable;
};
var isResponseWithoutContent = function (response) { return response.status === 204; };
var getErrorMessage = function (message, status, body) {
    return { error: true, message: message, status: status, body: body };
};
var serializeData = function (data) { return JSON.stringify(data); };
var fetchData = function (input, options) {
    return fetch_1.fromFetch(input, options).pipe(operators_1.switchMap(onSuccessFetch), operators_1.catchError(onErrorFetch));
};
var getHttpHeaders = function (headers) {
    // todo dinamicizzare quando funzionerà
    // const authHeader = 'OAuth oauth_consumer_key="Qwentes-Group",oauth_token="2U8UDUNY1N2E2WQAJZNUP2U369"';
    var baseHeaders = {
        'Content-type': 'application/json; charset=UTF-8'
    };
    return headers ? __assign(__assign({}, baseHeaders), headers) : baseHeaders;
};
var get = function (url, options) {
    if (options === void 0) { options = {}; }
    return fetchData(url, __assign(__assign({ method: 'GET' }, options), { headers: getHttpHeaders(options.headers) }));
};
var post = function (url, body, options) {
    if (options === void 0) { options = {}; }
    return fetchData(url, __assign(__assign({ method: 'POST', body: serializeData(body) }, options), { headers: getHttpHeaders(options.headers) }));
};
var patch = function (url, body, options) {
    if (options === void 0) { options = {}; }
    return fetchData(url, __assign(__assign({ method: 'PATCH', body: serializeData(body) }, options), { headers: getHttpHeaders(options.headers) }));
};
var httpDelete = function (url, options) {
    if (options === void 0) { options = {}; }
    return fetchData(url, __assign(__assign({ method: 'DELETE' }, options), { headers: getHttpHeaders(options.headers) }));
};
exports.Http = {
    get: get,
    post: post,
    "delete": httpDelete,
    patch: patch,
    error: error,
    isInvalidSessionResponse: isInvalidSessionResponse,
    isNotAcceptableResponse: isNotAcceptableResponse
};
//# sourceMappingURL=http.js.map